import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { NavConfig, NavConfigFn, NavigationConfigProvider } from '@capital-access/common/navigation';
import { CA_INTELLIGENCE_FEATURE_TOGGLE, CA_INTELLIGENCE_PATH } from './constants';

@Injectable()
export class CAIntelligenceNavConfigProvider implements NavigationConfigProvider {
  private store = inject(Store);

  resolveNavConfig: NavConfigFn = () => {
    return this.store.select(getFeatureToggle(CA_INTELLIGENCE_FEATURE_TOGGLE)).pipe(
      map(isEnabled => {
        return <NavConfig>{
          top: [
            {
              localizationKey: 'caIntelligence',
              icon: 'f-i-stars-outlined',
              order: 80,
              link: CA_INTELLIGENCE_PATH,
              enabled: isEnabled
            }
          ]
        };
      })
    );
  };
}
